module.exports = __webpack_public_path__ + "static/media/car details.a3343c21.png";